// MS50 #3001 — "select-navigate" Stimulus controller.
//
// CSP-safe replacement for the inline `onchange="window.location.href = ..."`
// navigation handler (the enforcing nonce CSP blocks inline handlers — #1222).
// On change, navigate to `url-value` carrying forward the current query string
// with the `param-value` param overridden by the select's current value. Used by
// the company/users#index "Show N per page" selector, which navigates by URL
// rather than submitting a form.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, param: String }

  navigate() {
    const params = new URLSearchParams(window.location.search)
    params.set(this.paramValue, this.element.value)
    const base = this.hasUrlValue ? this.urlValue : window.location.pathname
    window.location.href = `${base}?${params.toString()}`
  }
}
